import { useEffect, useState } from "react";
import { getUserRoles } from "../services/masterDataService";

export const useUserRoles = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const data = await getUserRoles();
        setRoles(data || []);
      } catch (err) {
        console.error("Failed to load user roles:", err);
        setRoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  return { roles, loading };
};